export class MiddleClickObserver {
    constructor() {
        this.selector = '[onmiddleclick]';
        this.handlerMap = new WeakMap(); // Хранение обработчиков для элементов
        this.init();
    }

    init() {
        // Обрабатываем существующие элементы при загрузке
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.processElements());
        } else {
            this.processElements();
        }

        // Наблюдаем за изменениями DOM
        this.setupMutationObserver();
    }

    processElements() {
        const elements = document.querySelectorAll(this.selector);
        elements.forEach(element => {
            this.attachMiddleClickHandler(element);
        });
    }

    setupMutationObserver() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                // Обработка добавления/удаления узлов
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            // Проверяем сам элемент
                            if (node.hasAttribute('onmiddleclick')) {
                                this.attachMiddleClickHandler(node);
                            }
                            // Проверяем дочерние элементы
                            const children = node.querySelectorAll(this.selector);
                            children.forEach(child => this.attachMiddleClickHandler(child));
                        }
                    });

                    mutation.removedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            // Очищаем обработчик с удаленного элемента
                            if (node.hasAttribute && node.hasAttribute('onmiddleclick')) {
                                this.detachMiddleClickHandler(node);
                            }
                            // Очищаем дочерние элементы
                            if (node.querySelectorAll) {
                                const children = node.querySelectorAll(this.selector);
                                children.forEach(child => this.detachMiddleClickHandler(child));
                            }
                        }
                    });
                }

                // Обработка изменения атрибутов
                if (mutation.type === 'attributes' && mutation.attributeName === 'onmiddleclick') {
                    const element = mutation.target;

                    // Удаляем старый обработчик
                    this.detachMiddleClickHandler(element);

                    // Если атрибут все еще существует - добавляем новый обработчик
                    if (element.hasAttribute('onmiddleclick')) {
                        this.attachMiddleClickHandler(element);
                    }
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['onmiddleclick'] // Отслеживаем только изменения onmiddleclick
        });
    }

    attachMiddleClickHandler(element) {
        // Если уже есть обработчик - не добавляем повторно
        if (this.handlerMap.has(element)) {
            return;
        }

        // Создаем обработчик события
        const handler = (event) => {
            // Проверяем что это средняя кнопка мыши
            if (event.button === 1) {
                event.preventDefault();
                event.stopPropagation();
                this.executeMiddleClickHandler(element, event);
            }
        };

        // Сохраняем обработчик в WeakMap
        this.handlerMap.set(element, handler);

        // Навешиваем обработчик на элемент
        element.addEventListener('auxclick', handler);

        // Добавляем визуальный индикатор
        if (!element.style.cursor || element.style.cursor === 'auto') {
            element.style.cursor = 'pointer';
        }
    }

    detachMiddleClickHandler(element) {
        // Получаем сохраненный обработчик
        const handler = this.handlerMap.get(element);

        if (handler) {
            // Удаляем обработчик события
            element.removeEventListener('auxclick', handler);

            // Удаляем из WeakMap
            this.handlerMap.delete(element);
        }
    }

    executeMiddleClickHandler(element, event) {
        const handlerCode = element.getAttribute('onmiddleclick');
        if (handlerCode) {
            try {
                // Создаем функцию из строки кода
                const handler = new Function('event', handlerCode);
                handler.call(element, event);
            } catch (error) {
                console.error('Error executing onmiddleclick handler:', error);
            }
        }
    }
}